import React, { useState } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';
import { MenuItem, Popover, TextField } from '@material-ui/core';
import Gravatar from 'react-gravatar';

import { useAuth } from 'hooks';
import { Spacer } from 'components';
import { logout, changeGroup, me } from 'store/modules/auth';
import ChangePasswordDialog from './ChangePasswordDialog';

import logo from 'static/Logo_full_black.png';
import styles from './Topbar.module.scss';

const Topbar = props => {
  const [dialog, setDialog] = useState({});
  const auth = useAuth() || {};

  const onGroupChange = e => {
    const id = e.target.value;

    if (id && id !== auth.currentGroup._id) {
      const group = auth.myGroups.find(({ _id }) => _id === id);

      if (group) {
        props.changeGroup(group);
      }
    }
  };

  const renderGroupSelector = () => {
    if (auth.currentGroup && auth.myGroups) {
      return (
        <TextField
          select
          label="Group"
          className={styles.group}
          value={auth.currentGroup._id}
          onChange={onGroupChange}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        >
          {auth.myGroups.map(it => (
            <MenuItem key={it._id} value={it._id}>
              {it.name}
            </MenuItem>
          ))}
        </TextField>
      );
    }
  };

  const renderUser = () => {
    return (
      <div
        className={styles.user}
        onClick={e => setDialog({ userMenu: e.currentTarget })}
      >
        <div className={styles.name}>
          {_.get(auth, 'user.fullname', 'Anonymous User')}
        </div>

        <Gravatar className={styles.avatar} email={_.get(auth, 'user.email')} size={40} />
      </div>
    );
  };

  const onCloseDialog = () => setDialog({});

  return (
    <div className={styles.topbar}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.spacer} />

      {renderUser()}
      <Spacer length={40} />
      {renderGroupSelector()}

      <Popover
        open={!!dialog.userMenu}
        anchorEl={dialog.userMenu}
        onClose={onCloseDialog}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={() => setDialog({ changePassword: true })}>
          Change password
        </MenuItem>

        <MenuItem
          onClick={() => {
            onCloseDialog();
            props.logout();
          }}
        >
          Logout
        </MenuItem>
      </Popover>

      <ChangePasswordDialog
        open={!!dialog.changePassword}
        onClose={done => {
          onCloseDialog();

          if (done) {
            props.logout();
          }
        }}
      />
    </div>
  );
};

export default connect(null, { logout, changeGroup, me })(Topbar);
